import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3444c42c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = { class: "text-start mb-3" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }
const _hoisted_4 = { class: "row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-4 row-cols-xl-4" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "align-self-end" }
const _hoisted_15 = { class: "demo-pagination-block mt-3 d-flex justify-content-end" }
const _hoisted_16 = { class: "dialog-footer" }
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = { class: "remark-text" }
const _hoisted_19 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_Operation = _resolveComponent("Operation")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Document = _resolveComponent("Document")!
  const _component_EditPen = _resolveComponent("EditPen")!
  const _component_ZoomIn = _resolveComponent("ZoomIn")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("TPS_team_code")), 1)
      ]),
      _createVNode(_component_el_form, {
        onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
        class: "mt-2",
        "label-position": 'right',
        "label-width": 'auto'
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                label: _ctx.t('PJCode') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchCriteria.pjCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchCriteria.pjCode) = $event)),
                    modelModifiers: { trim: true },
                    onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                    clearable: "",
                    placeholder: _ctx.t('placeholder.input')
                  }, null, 8, ["modelValue", "onKeyup", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                label: _ctx.t('creator') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.searchCriteria.creatorKeyword,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchCriteria.creatorKeyword) = $event)),
                    onKeyup: _withKeys(_ctx.onInputFieldEnterKeyUp, ["enter"]),
                    clearable: "",
                    placeholder: _ctx.t('placeholder.input')
                  }, null, 8, ["modelValue", "onKeyup", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                label: _ctx.t('site') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    placeholder: _ctx.t('placeholder.select'),
                    loading: _ctx.isSiteLoading,
                    "loading-text": _ctx.t('loading'),
                    onVisibleChange: _ctx.onSiteListShown,
                    modelValue: _ctx.searchCriteria.site,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchCriteria.site) = $event)),
                    "value-key": "id",
                    class: "w-100",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchCriteria.factory = undefined)),
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: site.id,
                          label: site.name,
                          value: site
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["placeholder", "loading", "loading-text", "onVisibleChange", "modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                label: _ctx.t('factory') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    placeholder: _ctx.t('placeholder.select'),
                    modelValue: _ctx.searchCriteria.factory,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchCriteria.factory) = $event)),
                    "value-key": "id",
                    class: "w-100",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchCriteria.site?.factories, (factory) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: factory.id,
                          label: factory.name,
                          value: factory
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["placeholder", "modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                label: _ctx.t('startDate') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.searchCriteria.startDate,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchCriteria.startDate) = $event)),
                    "value-format": "YYYY-MM-DD",
                    type: "month",
                    placeholder: _ctx.t('placeholder.date'),
                    style: {"width":"100%"},
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_form_item, {
                class: "w-100",
                label: _ctx.t('endDate') + ':'
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.searchCriteria.endDate,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchCriteria.endDate) = $event)),
                    "value-format": "YYYY-MM-DD",
                    type: "month",
                    placeholder: _ctx.t('placeholder.date'),
                    style: {"width":"100%"},
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_button, {
          type: "",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onClearSearchCriteriaClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("clear")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onSearchProjectClicked()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.t("search")), 1)
          ]),
          _: 1
        })
      ]),
      _hoisted_12,
      (_ctx.userInfoStore.permissions.some((x) => x === 420))
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            justify: "end",
            class: "mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 2,
                xs: 3,
                sm: 3,
                md: 2,
                lg: 2,
                xl: 2,
                class: "d-flex justify-content-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onCreateProjectClicked())),
                    disabled: !_ctx.userInfoStore.permissions.some((x) => x === 220)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.t("create")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_popover, {
            placement: "bottom",
            onHide: _ctx.onColDisplayCtrlPanelHidded,
            trigger: "click",
            Title: _ctx.t('column')
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, { link: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { size: 20 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Operation)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[0],
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.colDisplayCtrl[0]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("PJCode")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[1],
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.colDisplayCtrl[1]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("period")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[2],
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.colDisplayCtrl[2]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("startMonth")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[3],
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.colDisplayCtrl[3]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("endMonth")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[4],
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.colDisplayCtrl[4]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("factories")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[5],
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.colDisplayCtrl[5]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("factorys")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[6],
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.colDisplayCtrl[6]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("team")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[7],
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.colDisplayCtrl[7]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("payRate")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[8],
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.colDisplayCtrl[8]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("creator")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[9],
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.colDisplayCtrl[9]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("createDate")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.colDisplayCtrl[10],
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.colDisplayCtrl[10]) = $event))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("improvement_project")), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }, 8, ["onHide", "Title"])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          ref: "projectTableRef",
          class: "w-100",
          stripe: true,
          data: _ctx.displayProjects,
          "cell-style": _ctx.cellStyle,
          onSortChange: _ctx.onSortChanged
        }, {
          default: _withCtx(() => [
            (_ctx.colDisplayCtrl[0])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  "min-width": "140",
                  sortable: "custom",
                  label: _ctx.t('PJCode'),
                  prop: "pjCode"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[1])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 1,
                  "min-width": "80",
                  sortable: "custom",
                  label: _ctx.t('period'),
                  prop: "periodNum"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[2])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 2,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('startMonth'),
                  prop: "startMonth"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[3])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 3,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('endMonth'),
                  prop: "endMonth"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[4])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 4,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('factories'),
                  prop: "siteName"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[5])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 5,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('factorys'),
                  prop: "factoryName"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[6])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 6,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('team'),
                  prop: "teamNum"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[7])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 7,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('payRate'),
                  prop: "workRate"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[8])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 8,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('creator'),
                  prop: "creatorDisplayName"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[9])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 9,
                  "min-width": "120",
                  sortable: "custom",
                  label: _ctx.t('createDate'),
                  prop: "createTime"
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (_ctx.colDisplayCtrl[10])
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 10,
                  "min-width": "120",
                  align: "center",
                  label: _ctx.t('improvement_project'),
                  prop: "improvementProject"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      link: "",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.onKaizenItemLinkClicked(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Document)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_table_column, {
              width: "80",
              label: _ctx.t('operation'),
              prop: "operate",
              class: "operateBtnGroup d-flex",
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                (_ctx.userInfoStore.permissions.some((x) => x === 420))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      link: "",
                      type: "success",
                      onClick: ($event: any) => (_ctx.onEditProjectClicked(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_EditPen)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      link: "",
                      type: "primary",
                      onClick: ($event: any) => (_ctx.onViewProjectClicked(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ZoomIn)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])),
                (_ctx.userInfoStore.permissions.some((x) => x === 420))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      link: "",
                      type: "danger",
                      onClick: ($event: any) => (_ctx.onDeleteProjectClicked(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      link: "",
                      type: "info",
                      onClick: ($event: any) => (_ctx.onDeleteProjectClicked(scope.row)),
                      disabled: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, { size: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data", "cell-style", "onSortChange"])), [
          [
            _directive_loading,
            _ctx.isTableLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _createVNode(_component_el_row, {
        justify: "end",
        class: "mt-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_pagination, {
                  currentPage: _ctx.currentPage,
                  "onUpdate:currentPage": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.currentPage) = $event)),
                  "page-size": _ctx.pageSize,
                  "onUpdate:page-size": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.pageSize) = $event)),
                  "pager-count": _ctx.paginatorSetup.pagerCount,
                  layout: _ctx.paginatorSetup.layout,
                  small: _ctx.paginatorSetup.small,
                  "page-sizes": [20, 50, 100],
                  total: _ctx.filteredProjects.length,
                  onSizeChange: _ctx.onPagesizeChanged,
                  onCurrentChange: _ctx.onCurrentPageChanged,
                  justify: "end"
                }, null, 8, ["currentPage", "page-size", "pager-count", "layout", "small", "total", "onSizeChange", "onCurrentChange"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: _ctx.isShowAddDialog,
      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.isShowAddDialog) = $event)),
      title: _ctx.t('create')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_16, [
          _createVNode(_component_el_button, {
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.isShowAddDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onSubmitNewProjectClicked()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          onSubmit: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["prevent"])),
          ref: "createProjectFormRef",
          model: _ctx.newProjectData,
          rules: _ctx.projectFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.creator'),
              prop: "creator",
              class: "text-nowrap col-lg-8 col-12",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.newProjectData.creator?.displayName) + " (" + _toDisplayString(_ctx.newProjectData.creator?.username) + ")", 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.period'),
              prop: "period",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.newProjectData.period,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newProjectData.period) = $event)),
                  placeholder: _ctx.t('placeholder.input'),
                  "value-key": "id"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periods, (period) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: period.id,
                        label: period.periodNum,
                        value: period
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.month_range'),
              prop: "duration",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.newProjectData.period?.startMonth) + " ~ " + _toDisplayString(_ctx.newProjectData.period?.endMonth), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.site'),
              prop: "site",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: _ctx.t('placeholder.select'),
                  loading: _ctx.isSiteLoading,
                  "loading-text": _ctx.t('loading'),
                  onVisibleChange: _ctx.onSiteListShown,
                  modelValue: _ctx.newProjectData.site,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newProjectData.site) = $event)),
                  "value-key": "id",
                  class: "w-100",
                  onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.newProjectData.factory = undefined))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: site.id,
                        label: site.name,
                        value: site
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["placeholder", "loading", "loading-text", "onVisibleChange", "modelValue"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.factory'),
              prop: "factory",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  placeholder: _ctx.t('placeholder.select_hint'),
                  modelValue: _ctx.newProjectData.factory,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.newProjectData.factory) = $event)),
                  "value-key": "id",
                  class: "w-100"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newProjectData.site?.factories, (factory) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: factory.id,
                        label: factory.name,
                        value: factory
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.team_name'),
              prop: "teamNum",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.newProjectData.teamNum,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.newProjectData.teamNum) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.work_rate'),
              prop: "workRate",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.newProjectData.workRate,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.newProjectData.workRate) = $event)),
                  min: 0,
                  precision: 2,
                  controls: false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.remark'),
              prop: "remark",
              class: "text-nowrap",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.newProjectData.remark,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.newProjectData.remark) = $event)),
                  rows: 4,
                  type: "textarea",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"])
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [
            _directive_loading,
            _ctx.isAddDialogLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: _ctx.isShowModifyDialog,
      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.isShowModifyDialog) = $event)),
      title: _ctx.t('modify')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_el_button, {
            onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.isShowModifyDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onSaveModifyResultClicked()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          onSubmit: _cache[37] || (_cache[37] = _withModifiers(() => {}, ["prevent"])),
          ref: "editProjectFormRef",
          model: _ctx.selectedProjectData,
          rules: _ctx.projectFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.creator'),
              prop: "creator",
              class: "text-nowrap col-lg-8 col-12",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.creator?.displayName) + " (" + _toDisplayString(_ctx.selectedProjectData.creator?.username) + ")", 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.period'),
              prop: "period",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.period?.periodNum), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.month_range'),
              prop: "duration",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.period?.startMonth) + " ~ " + _toDisplayString(_ctx.selectedProjectData.period?.endMonth), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.site'),
              prop: "site",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.site?.name), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.factory'),
              prop: "factory",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.factory?.name), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.team_name'),
              prop: "teamNum",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.teamNum), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.work_rate'),
              prop: "workRate",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: _ctx.selectedProjectData.workRate,
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.selectedProjectData.workRate) = $event)),
                  min: 0,
                  precision: 2,
                  controls: false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.remark'),
              prop: "remark",
              class: "text-nowrap",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.selectedProjectData.remark,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.selectedProjectData.remark) = $event)),
                  rows: 4,
                  type: "textarea",
                  placeholder: _ctx.t('placeholder.input')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "label-width"])
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [
            _directive_loading,
            _ctx.isModifyDialogLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "dialog",
      modelValue: _ctx.isShowViewDialog,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.isShowViewDialog) = $event)),
      title: _ctx.t('detail')
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_19, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.isShowViewDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t("Confirm")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_form, {
          onSubmit: _cache[41] || (_cache[41] = _withModifiers(() => {}, ["prevent"])),
          ref: "editProjectFormRef",
          model: _ctx.selectedProjectData,
          rules: _ctx.projectFormRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.creator'),
              prop: "creator",
              class: "text-nowrap col-lg-8 col-12",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.creator?.displayName) + " (" + _toDisplayString(_ctx.selectedProjectData.creator?.username) + ")", 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.period'),
              prop: "duration",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.period?.periodNum), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.month_range'),
              prop: "duration",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.period?.startMonth) + " ~ " + _toDisplayString(_ctx.selectedProjectData.period?.endMonth), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.site'),
              prop: "site",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.site?.name), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.factory'),
              prop: "factory",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.factory?.name), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.team_name'),
              prop: "teamNum",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.selectedProjectData.teamNum), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.work_rate'),
              prop: "workRate",
              "label-width": _ctx.formLabelWidth,
              class: "col-lg-8 col-12"
            }, {
              default: _withCtx(() => [
                _createElementVNode("label", null, _toDisplayString(_ctx.numeral(_ctx.selectedProjectData.workRate).format("0.0")), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.t('form.label.remark'),
              prop: "remark",
              class: "text-nowrap",
              "label-width": _ctx.formLabelWidth
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.selectedProjectData.remark), 1)
              ]),
              _: 1
            }, 8, ["label", "label-width"])
          ]),
          _: 1
        }, 8, ["model", "rules"])), [
          [
            _directive_loading,
            _ctx.isModifyDialogLoading,
            void 0,
            {
              fullscreen: true,
              lock: true
            }
          ]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}